// extracted by mini-css-extract-plugin
export default {"loader":"loader_loader__C4Jrw","fadeInOut":"loader_fadeInOut__XiLwd","shadow324":"loader_shadow324__A6JRs","jump7456":"loader_jump7456__ifJhQ"};